import Vue from "vue";
import Router from "vue-router";
import routes from "./routers";
// import config from '@/config'
// const { homeName } = config

Vue.use(Router);
const router = new Router({
  routes,
  mode: "history"
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js